import React from 'react';
import classNames from 'classnames';

import css from './IconShipping.module.css';

/**
 * Delivery truck icon, used to indicate that a listing offers shipping.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconShipping = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path d="M2 5.5h11v10H2v-10Z" />
      <path d="M13 8.5h4l3 3v4h-7v-7Z" />
      <path d="M6.5 18.5c.82843 0 1.5-.6716 1.5-1.5s-.67157-1.5-1.5-1.5S5 16.1716 5 17s.67157 1.5 1.5 1.5Z" />
      <path d="M16.5 18.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z" />
    </svg>
  );
};

export default IconShipping;
